import { Injectable } from '@angular/core';
import { Menu } from 'src/app/_model/menu';
import { KeyValuePersistenceService } from '../../../persistence/key-value-persistence/key-value-persistence.service';
import { MenuDaoService } from '../menu-dao.service';

// CONSTANTS
const KEY_MENU = 'menu';

/**
 * DataAccessObject for Menus
 */
@Injectable()
export class MenuStorageDaoService implements MenuDaoService {
  // Lifecycle
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  // MenuDaoService
  public async saveMenu(menu: Menu): Promise<void> {
    await this.keyValueStorage.store(KEY_MENU, menu);
  }

  public async loadMenu(): Promise<Menu> {
    return await this.keyValueStorage.load(KEY_MENU);
  }

  public async reset() {}
  public async clear() {
    await this.keyValueStorage.delete(KEY_MENU);
  }
}
